import { normalize } from "utils/normalize";

const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case "GET_COMPANIES_SUCCESS":
      return { ...state, ...normalize(action.companies) };
    case "GET_COMPANIES_BY_COUNTY_AND_CATEGORY_SUCCESS":
    case "GET_COMPANIES_BY_SEARCH_SUCCESS":
      return { ...normalize(action.companies) };
    case "CREATE_COMPANY_SUCCESS":
    case "GET_COMPANY_SUCCESS":
    case "UPDATE_COMPANY_SUCCESS":
      return { [action.company.id]: action.company };
    case "DESTROY_COMPANY_SUCCESS":
      const { [action.id.toString()]: deleted, ...rest } = state;
      return rest;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/data/companies/reducer.js